import { delegate } from "../../utils/delegate"

function amount() {
	delegate("click", ".amount__button", (e, btn) => {
		e.preventDefault()

		const input = btn.parentNode.querySelector(".amount__input")

		const value = parseInt(input.value)
		const max = parseInt(input.max)
		const min = parseInt(input.min)
		const step = parseInt(input.step)

		if (btn.classList.contains("plus")) {
			if (value >= max) return
			input.value = value + step
		} else {
			if (value <= min) return
			input.value = value - step
		}

		input.dispatchEvent(new CustomEvent("changeValue"))
	})

	delegate("change", ".amount__input", (e, input) => {
		const value = parseInt(input.value)
		const max = parseInt(input.max)
		const min = parseInt(input.min)
		const step = parseInt(input.step)

		if (value > max) {
			input.value = max
		} else if (value < min) {
			input.value = min
		}

		input.dispatchEvent(new CustomEvent("changeValue"))
	})
}
amount()
